import React, { useState } from 'react';
import cn from 'classnames';
import Transition from 'react-transition-group/Transition';
import { CloseIcon } from "../Icon/HmIcons";
import BodyText from "../Typography/texts/BodyText";
import HeadingSmall from "../Typography/titles/HeadingSmall";
import Button from '../CTA/Button';
import IconButton from '../CTA/IconButton';
import styles from './Message.module.scss';
const Message = ({ heading, text, cta, isClosable, label, onMessageClose }) => {
    const [isOpen, setState] = useState(true);
    const handleCloseClick = () => {
        setState(!isOpen);
        if (onMessageClose) {
            onMessageClose();
        }
    };
    return (React.createElement(Transition, { in: isOpen, timeout: { enter: 0, exit: 300 }, unmountOnExit: true }, (transitionState) => (React.createElement("div", { className: cn(styles.container, styles[transitionState]) },
        React.createElement("div", { className: styles.inner },
            isClosable && (React.createElement(IconButton, { className: styles.closeButton, onClick: handleCloseClick, iconElement: React.createElement(CloseIcon, { size: "small" }) }, label)),
            React.createElement("div", null,
                heading && React.createElement(HeadingSmall, { marginless: true }, heading),
                React.createElement(BodyText, null, text)),
            cta && (React.createElement(Button, Object.assign({ secondary: true, size: "large", className: styles.closable }, cta), cta.text)))))));
};
export default Message;
//# sourceMappingURL=Message.js.map